import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Styled from '../../../lab/Styled';
import TextField from '@material-ui/core/TextField';
/**
 * @extends {React.Component<import('./types').NumericTextFieldProps>}
 */

var NumericTextField =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NumericTextField, _React$Component);

  function NumericTextField(props) {
    var _this;

    _classCallCheck(this, NumericTextField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumericTextField).call(this, props));

    _this.handleBlur = function () {
      _this.submitChange();
    };

    _this.handleKeyDown = function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();

        _this.submitChange();
      }
    };

    _this.handleChange = function (e) {
      _this.setState({
        pendingChanges: true,
        pendingValue: e.target.value
      });
    };

    _this.submitChange = function () {
      var _this$state = _this.state,
          pendingChanges = _this$state.pendingChanges,
          pendingValue = _this$state.pendingValue;

      if (pendingChanges) {
        var _this$props = _this.props,
            unspecifiedValue = _this$props.unspecifiedValue,
            parse = _this$props.parse;
        var newValue = parseFn(pendingValue, unspecifiedValue, parse);

        _this.props.onChange(newValue);
      }
    };

    _this.renderTextField = function (classes) {
      var _this$props2 = _this.props,
          label = _this$props2.label,
          width = _this$props2.width,
          disabled = _this$props2.disabled;
      var pendingValue = _this.state.pendingValue;
      /**@type {import('@material-ui/core/TextField').BaseTextFieldProps} */

      var textFieldProps = {
        className: classes.textField,
        margin: 'none',
        SelectProps: {
          MenuProps: {
            className: classes.menu
          }
        }
      };

      if (width === 'stretch') {
        textFieldProps.fullWidth = true;
      } else {
        textFieldProps.style = {
          width: width
        };
      }

      return React.createElement(TextField, Object.assign({}, textFieldProps, {
        id: "select-number",
        label: label,
        value: pendingValue,
        onChange: _this.handleChange,
        onBlur: _this.handleBlur,
        onKeyDown: _this.handleKeyDown,
        disabled: disabled
      }));
    };

    var _this$props3 = _this.props,
        value = _this$props3.value,
        _unspecifiedValue = _this$props3.unspecifiedValue,
        format = _this$props3.format;
    _this.state = {
      prevProps: _this.props,
      pendingChanges: false,
      pendingValue: formatFn(value, _unspecifiedValue, format)
    };
    return _this;
  }

  _createClass(NumericTextField, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        "data-testid": "numeric-text-field"
      }, React.createElement(Styled, {
        theme: true,
        styles: styles,
        name: "ECNumericTextField"
      }, this.renderTextField));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(newProps, currentState) {
      var newValue = newProps.value,
          newUnspecifiedValue = newProps.unspecifiedValue,
          newFormat = newProps.format;
      var _currentState$prevPro = currentState.prevProps,
          value = _currentState$prevPro.value,
          unspecifiedValue = _currentState$prevPro.unspecifiedValue,
          format = _currentState$prevPro.format;
      if (newValue === value && newUnspecifiedValue === unspecifiedValue && newFormat === format) return null;
      return {
        prevProps: newProps,
        pendingChanges: false,
        pendingValue: formatFn(newValue, newUnspecifiedValue, newFormat)
      };
    }
  }]);

  return NumericTextField;
}(React.Component);

var formatFn = function formatFn(val, nullLabel, labelFn) {
  if (val === null) return nullLabel;
  if (labelFn) return labelFn(val);
  if (!val) return nullLabel;
  return val;
};

var parseFn = function parseFn(textVal, nullLabel, parse) {
  if (textVal === nullLabel) return null;
  if (parse) return parse(textVal);
  var newValue = parseFloat(textVal);
  if (Number.isNaN(newValue)) return null;
  return newValue;
};

var styles = function styles() {
  return {
    textField: {}
  };
};

NumericTextField.defaultProps = {
  value: null,
  disabled: false,
  label: 'Value',
  unspecifiedValue: 'inherit',
  width: 60
};
export default NumericTextField;